import Phaser from "phaser";
import { PowerUpType } from "../../data/enums";

export class PowerUpBase extends Phaser.Physics.Arcade.Sprite {
    readonly powerUpType: PowerUpType;
    readonly expiresAt: number;

    constructor(scene: Phaser.Scene, x: number, y: number, textureKey: string, powerUpType: PowerUpType, durationMs: number) {
        super(scene, x, y, textureKey);
        this.powerUpType = powerUpType;
        this.expiresAt = scene.time.now + durationMs;
        scene.add.existing(this);
        scene.physics.add.existing(this);
        this.setDepth(7);
        this.setCircle(14);
    }

    update(time: number): void {
        const bob = Math.sin(time / 220) * 0.35;
        this.y += bob;
    }
}
